import CardDetailsPage from './CardDetailsPage';

export default CardDetailsPage;